<template>
  <div class="teaser-map-placeholder">
    <img
      src="~/assets/images/map-teaser-background.png"
      width="1188"
      height="160"
      alt="Map"
      loading="lazy"
    />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    title?: string
    isLoading?: boolean
    isRect?: boolean
  }>(),
  {
    title: '',
    isLoading: false,
    isRect: false,
  },
)
</script>

<style>
.teaser-map-placeholder {
  height: 15rem;
  img {
    height: 100%;
    object-fit: cover;
  }
}
</style>
